import 'moment/locale/it';
// import { Link } from "gatsby"
// import { useLayoutEffect } from 'react'
import moment from "moment/moment";
import React from "react";
import styled from 'styled-components';
// import { document } from 'browser-monads';
import srcImgFeatured from '../fonts/img_featured_placeholder.jpg';
import { CategoryColor } from '../utils/CategoryColor';
import BookmarkButton from './bookmark-button';
import { DesktopFollowingPanel } from "./desktop-following-panel";
import FontSizeButton from "./font-size";
import ListCategories from './list-categories';
import { UrlsUtils } from '../utils/UrlsUtils';
// import ListCategories  from './list-categories';
// import SharePanel  from './share';
import ShareButton from './share-button';
import EditPostButton from "./edit-post-button"

const ReadingTimeStyle = styled.div`
    position: absolute;
    bottom: 18px;
    right: 0px;
    height: 22px;
    font-size: 12px;
    padding: 0px 10px 0px 10px;
    margin-right: 10px;
    background-color: #FFFFFF;
    border-radius: 10px / 10px;
    color: #B2B4CA;
`

// function readingTime(html_element) {
//     var words = html_element.textContent.split(' ').filter(item => {return item !== "";})
//     var words_count = words.length;
//     //alert(words_count);
//     //var words_count = 640;
//     var time = 60;
//     var words_per_minutes = 300;
//     return fmtMSS(Math.round((words_count/words_per_minutes) * time))
// }

// function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

function PostHeaderMeta ({ title, author, date, excerpt, featuredImage, template, categories,
  categoria_landing_img, categoria_landing_text, categoria_landing_link, primary_category, vertical,
  uri, video_embedded_home, video_content, time_read, base_id, vertical_feature_image_position,
  postId, kind, from404
}) {
  console.log('node___ categoria_landing_link', categoria_landing_link);

  if (primary_category === 'Unstoppable Women') categoria_landing_link = "/unstoppablewomen/"

  // useLayoutEffect(()=>{
  //   //alert(document.querySelector("#entry-content"));
  //   var value = readingTime(document.querySelector("#entry-content"));
  //   //var value="1:00";
  //   document.querySelector("#entry-post-date-reading").innerText="⏱Tempo di lett. "+value;
  //   return () => {
  //   };
  // });
      //Used in rendering at build time but changes for every page/post
  if (vertical === "life") {
    categoria_landing_img = "https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png";
    categoria_landing_link = "/life/";
    primary_category = 'LIFE';
  } else if (vertical === "valoreresponsabile") {
    categoria_landing_img = "https://cdn.startupitalia.eu/wp-content/uploads/sites/20/2020/12/29131645/mediobanca-1.png";
    categoria_landing_link = "/valoreresponsabile/";
    primary_category = 'VALORE RESPONSABILE';
  } else if (vertical === "smartmoney") {
    categoria_landing_img = "https://cdn.startupitalia.eu/wp-content/uploads/sites/7/2015/02/illimity-logo-1.png";
    categoria_landing_link = "/smartmoney/";
    primary_category = 'SMART MONEY';
  }

  const sponsored_visibility = (template !== "default" && categoria_landing_img) ? "block" : "none";

  // var first = 0;

  var _categories = [];

  if (categories) {
    if (categories.nodes) {
      _categories = categories.nodes;
    } else if (typeof categories === typeof []) {
      _categories = categories;
    }
  }
  return (
    <header className="entry-headers">
      <div
        className="show_desktop"
        style={{
          position: "relative",
          // margin: "60px 0px 60px 0px",
          margin: "0px",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        <div
          // id="entry-post-featuredImage-desk"
          style={{
            display: "block",
            width: "100%",
            paddingBottom: "calc(100%*1/3)",
            // linear-gradient(
            //   rgba(255, 255, 255, 0) 0%,
            //   rgba(255, 255, 255, 0) 55%,
            //   rgba(11, 1, 53, 0.6) 60%,
            //   rgba(11, 1, 53, 0.6) 100%),
            // backgroundImage: `
            //   url(${featuredImage.mediaItemUrl || srcImgFeatured})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <img
            id="entry-post-featuredImage-desk"
            className={"entry-post-featuredImage-desk"}
            // width="100%"
            // height="100%"
            style={{
              display: "block",
              position: "absolute",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition:
                "center " +
                (vertical_feature_image_position !== null
                  ? vertical_feature_image_position
                  : "50") +
                "%",
            }}
            srcSet={
              featuredImage && featuredImage.mediaItemUrl
                ? UrlsUtils.ensure_wp_content(featuredImage.srcSet)
                : typeof featuredImage === typeof "" && featuredImage !== ""
                ? UrlsUtils.ensure_wp_content(featuredImage)
                : UrlsUtils.ensure_wp_content(srcImgFeatured)
            }
            alt={"desc"}
          />
          <div
            style={{
              position: "absolute",
              // top: '0rem',
              /* padding-bottom: 13%; */
              // float: 'left',
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              // paddingTop: 'calc((100%/16*9)*65/100)'
              backgroundImage: `
              linear-gradient(
                rgba(11, 1, 53, 0) 0%,
                rgba(11, 1, 53, 1) 100%)
              `,
            }}
            className={"theme-background-shadow-gradient"}
          >
            <div
              style={{
                maxWidth: "unset",
                padding: "8% 0% 2% 0%",
                margin: "0",
                // backgroundImage: `
                // linear-gradient(
                //   rgba(11, 1, 53, 0) 0%,
                //   rgba(11, 1, 53, 0.2) 10%,
                //   rgba(11, 1, 53, 0.4) 20%,
                //   rgba(11, 1, 53, 0.6) 30%,
                //   rgba(11, 1, 53, 1) 100%)
                // `,
                textAlign: "left",
              }}
              // className="theme-background-shadow-gradient"
            >
              <div className="entry-part-container">
                <a
                  style={{ marginRight: "auto", display: "inline-block" }}
                  className={"entry_primary_category_link"}
                  href={categoria_landing_link}
                >
                  <div
                    className="entry_primary_category newmag_mobile_primary_category"
                    style={{
                      marginRight: "15px",
                      minWidth: "68px",
                      fontSize: "13px",
                      borderRadius: "7px",
                      // backgroundColor: "gray",
                      backgroundColor: new CategoryColor(primary_category)
                        .color,
                      color: "white",
                      textAlign: "center",
                      width: "fit-content",
                      padding: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    {primary_category}
                  </div>
                </a>
              </div>
            </div>
            <h1
              style={{ maxWidth: "unset", paddingBottom: "2%" }}
              // className="theme-background-shadow"
            >
              <span
                className="entry-title"
                style={{ display: "block", textAlign: "left" }}
                // dangerouslySetInnerHTML={{ __html: title }}
              >
                <span
                  style={{
                    display: "block",
                    color: "white",
                    lineHeight: "38px",
                    letterSpacing: "0.57px",
                  }}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </span>
            </h1>
            {/* <div
              style={{maxWidth: 'unset', padding: '0 5%', margin: '0', background: 'rgba(11, 1, 53, 0.6)'}}
              className="entry-excerpt theme-background-shadow" dangerouslySetInnerHTML={{ __html: excerpt }}
            /> */}
            <div
            // className="theme-background-shadow"
            >
              <div
                className="entry-part-container"
                style={{ display: "flex", paddingBottom: "2rem" }}
              >
                <div
                  className="show_desktop entry-subcategories"
                  style={{ display: "flex", marginLeft: 0 }}
                >
                  <ListCategories
                    categories={_categories}
                    primary_category={primary_category}
                  ></ListCategories>
                </div>
                <div style={{ marginLeft: "auto" }}>
                  <time
                    style={{
                      textTransform: "none",
                      float: "left",
                      marginLeft: "0px",
                      width: "100%",
                      color: "white",
                    }}
                    className="show_desktop entry-date published updated"
                    id="entry-post-date-reading"
                    // dateTime="2019-02-04T15:34:08+00:00"
                  >
                    &nbsp;⏱ Leggi in {time_read} min
                  </time>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {JSON.stringify(featuredImage)} */}
      </div>
      <div className="entry-metas">
        <div
          className="show_mobile"
          style={{
            margin: "0px 0px 20px 0px",
            position: "relative",
            overflow: "hidden",
            textAlign: "center",
          }}
        >
          {/* <div
            style={{
              textTransform: "none",
              float: "right",
              marginLeft: "auto",
              width: "100%",
              height: '22px',
              width: '85px',
              borderRadius: '13.5px',
              backgroundColor: '#FFFFFF',
              position: 'absolute',
              top: '78px',
              right: '12px',
              zIndex: '10',
              height: 'rem',
            }}
            id="entry-post-date-reading"
          >
            <span style={{
              color: '#B2B4CA',
              fontFamily: "urw-din",
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '24px',
              textAlign: 'right',
            }}>
              &nbsp; ⏱{time_read} min read
            </span>
          </div> */}

          <img
            id="entry-post-featuredImage-mobile"
            width="100%"
            height="100%"
            style={{ display: "block" }}
            srcSet={
              featuredImage && featuredImage.mediaItemUrl
                ? UrlsUtils.ensure_wp_content(featuredImage.srcSet)
                : typeof featuredImage === typeof "" && featuredImage !== ""
                ? UrlsUtils.ensure_wp_content(featuredImage)
                : UrlsUtils.ensure_wp_content(srcImgFeatured)
            }
            alt={"desc"}
          />
          <ReadingTimeStyle id={"reading_time"}>
            &nbsp; ⏱{time_read} min read
          </ReadingTimeStyle>
        </div>

        <div
          className="entry-sponsored-div"
          id="sponsored_div"
          style={{
            display: sponsored_visibility,
            // height: "90px",
            marginTop: "2rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: "10px", fontSize: "12px" }}>
              {categoria_landing_text
                ? categoria_landing_text
                : "In collaborazione con"}
            </span>
            <a
              style={{ width: "fit-content" }}
              href={
                categoria_landing_link
                  ? categoria_landing_link
                      .replace("https://new.startupitalia.eu", "")
                      .replace("http://new.startupitalia.eu", "")
                  : ""
              }
            >
              <img
                className="sponsored_div_img_desk"
                style={{
                  filter: "none",
                  height: "60px",
                  objectFit: "contain",
                }}
                src={categoria_landing_img ? categoria_landing_img : ""}
                alt={"desc"}
              />
            </a>
          </div>
        </div>
      </div>
      <div className="show_desktop" style={{ marginTop: "20px" }} />
      <div
        className="show_mobile entry-part-container"
        style={{ marginBottom: "20px", display: "flex" }}
      >
        <a
          style={{ marginRight: "auto" }}
          className={"entry_primary_category_link"}
          href={categoria_landing_link}
        >
          <div
            className="entry_primary_category newmag_mobile_primary_category"
            style={{
              marginRight: "15px",
              minWidth: "68px",
              fontSize: "13px",
              borderRadius: "5px",
              // backgroundColor: "gray",
              backgroundColor: new CategoryColor(primary_category).color,
              color: "white",
              textAlign: "center",
              width: "fit-content",
              padding: "10px",
            }}
          >
            <span
              style={{
                fontFamily: "urw-din",
                fontSize: "13px",
                fontWeight: "bold",
                letterSpacing: "0",
                textAlign: "center",
              }}
            >
              {primary_category}
            </span>
          </div>
        </a>
        {/* <SharePanel
        title={title}
        components_name_md5={"_headermobile"+uri}
        img={featuredImage?featuredImage.mediaItemUrl:""}
        author={author && author.name ? author.name : ""}
        video={JSON.stringify(video_embedded_home)}
        is_media={video_content}
        // showonly_option={true}
      /> */}
        <div
          style={{
            margin: "auto",
            marginLeft: "0.5rem",
            marginRight: "0.5rem",
          }}
        >
          <EditPostButton postId={postId} vertical={vertical} kind={kind} />
        </div>
        <div
          style={{
            margin: "auto",
            marginLeft: "0.5rem",
            marginRight: "0.5rem",
          }}
        >
          {
            from404 ?
            '' :
            <div>
              <ShareButton title={title} uri={uri} />
            </div>
          }
        </div>
        <div
          style={{
            margin: "auto",
            marginLeft: "0.5rem",
            marginRight: "0.5rem",
          }}
        >
          <FontSizeButton />
        </div>
        <div
          style={{
            margin: "auto",
            marginLeft: "0.5rem",
            marginRight: "0.5rem",
          }}
        >
          <BookmarkButton
            news_url={uri}
            // news_title={title}
            // news_image={featuredImage?featuredImage.mediaItemUrl:""}
            // news_author={author && author.node ? author.node : author}
            // news_video={video_content}
            // news_is_media={video_content}
            // news_category={primary_category}
            // news_excerpt={excerpt}
            // news_date={date}
            // components_name_md5={"_headermobile"+uri}
            style={{
              margin: "auto",
              marginLeft: "1rem",
              marginRight: "1rem",
            }}
          />
        </div>
      </div>
      <h1
        className="show_mobile entry-title"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <DesktopFollowingPanel
        title={title}
        uri={uri}
        image={featuredImage ? featuredImage.mediaItemUrl : ""}
        author={author && author.node ? author.node : author}
        video={video_content}
        is_media={video_content}
        id={"following-panel-" + base_id}
        top_ref_element_query_elector={base_id + " .entry-excerpt"}
        bottom_ref_element_query_elector={base_id + " footer.entry-footer"}
        zero_ref_element_query_elector={base_id}
        postId={postId}
        vertical={vertical}
        kind={kind}
        from404={from404}
      />
      <div
        className="show_mobile entry-excerpt"
        style={{ lineHeight: "35px" }}
        dangerouslySetInnerHTML={{ __html: excerpt }}
      />
      <div
        className="show_desktop entry-excerpt"
        style={{ lineHeight: "35px" }}
        dangerouslySetInnerHTML={{ __html: excerpt }}
      />
      <div
        className="show_mobile entry-subcategories"
        style={{ display: "flex", marginBottom: "20px" }}
      >
        <ListCategories
          categories={_categories}
          primary_category={primary_category}
        ></ListCategories>
      </div>
      <div
        style={{ display: "flex", marginTop: "2rem", marginBottom: "2rem" }}
        className="author vcard entry-part-container"
      >
        <div className="entry-author">
          <a
            id="entry-author-link"
            href={`/author/${author ? author.node.slug : ""}`}
          >
            <img
              className="entry-author-avatar"
              style={{ marginTop: 0 }}
              src={author ? author.node.avatar.url : ""}
              alt={"author avatar"}
            />
          </a>
          <a
            id="entry-author-link"
            href={`/author/${author ? author.node.slug : ""}`}
          >
            <div
              id="entry-author-name"
              style={{
                display: "inline",
                marginLeft: "12px",
                color: "#b2b4ca",
              }}
            >
              {author ? author.node.name : ""}
            </div>
          </a>
        </div>
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ margin: "auto" }} className="entry-post-date">
            <time
              id="entry-post-date-text"
              className="entry-date published updated"
              style={{ color: "#b2b4ca" }}
              dateTime="2019-02-04T15:34:08+00:00"
            >
              {moment(date).locale("it").format(`D MMM YYYY`)}
            </time>
            {/*
          <time
            style={{textTransform: "none", float: "left", marginLeft: "0px", width: "100%"}}
            className="show_desktop entry-date published updated"
            id="entry-post-date-reading"
            dateTime="2019-02-04T15:34:08+00:00">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;⏱Tempo di lett.

          </time>
          */}
          </div>
        </div>
      </div>
    </header>
  )}

export default PostHeaderMeta
